import { AxiosResponse } from 'axios';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useEffect, useRef, useState } from 'react';
import { ModelOfVehicleItem, ModelOfVehicleItemForm } from '../../database';
import api from '../../services/api';
import { useAuth } from 'src/contexts/auth';
import { useData } from 'src/contexts/data';
import { useUploadController } from '../ImageUpload/UploadController';

const initialValuesOfVehicle = {
	AX_ESTOQUE: '',
	PLACA: '',
	DESCRICAO: '',
	SIGLA: '',
	MARCADORKM: '',
	COR: '',
	ANOFABRICACAO: 0,
	ANOMODELO: 0,
	FT_CATEGORIA: '',
	CERTIFICADOREGISTRO: '',
	CAPCIDADEPOTENCIACILINDRADA: '',
	NUMEROCHASSI: '',
	NUMEROMOTOR: '',
	CAPACIDADECOMBUSTIVEL: '',
	RENAVAM: '',
	ANOLICENCIADO: 0,
	FT_TIPOQUILOMETRAGEM: '',
	FT_MARCA: '',
	TIPOCOMBUSTIVEL: {
		ID: [],
	},
	ORGAOUNIDADE: '',
	STATUS: 1,
	FT_ESPECIE: '',
};

export const useListVehiclesController = () => {
	const { handleUpload } = useUploadController();
	const { imageUploading } = useData();
	const { userAgencyId } = useAuth();
	const [allVehiclesData, setAllVehiclesData] = useState<ModelOfVehicleItem[]>([]);
	const [vehiclesData, setVehiclesData] = useState<ModelOfVehicleItem[]>([]);
	const [selectedVehicle, setSelectedVehicle] = useState<ModelOfVehicleItem>(initialValuesOfVehicle);
	const [loading, setLoading] = useState(true);
	const [loadingRows, setLoadingRows] = useState(false);
	const [loadingEdit, setLoadingEdit] = useState(false);
	const [editDialog, setEditDialog] = useState(false);
	const [deleteDialog, setDeleteDialog] = useState(false);
	const [rows, setRows] = useState(0);
	const [maxData, setMaxData] = useState(false);

	const toast: any = useRef();

	const validationSchema = Yup.object().shape({
		AX_ESTOQUE: Yup.string().required('* Campo obrigatório. Selecione uma opção da lista'),
		PLACA: Yup.string().required('* Campo obrigatório'),
		//DESCRICAO: Yup.string().required('* Campo obrigatório'),
		//SIGLA: Yup.string().required('* Campo obrigatório'),
		//MARCADORKM: Yup.string().required('* Campo obrigatório'),
		COR: Yup.string().required('* Campo obrigatório'),
		//ANOFABRICACAO: Yup.string().required('* Campo obrigatório'),
		//ANOMODELO: Yup.string().optional(),
		//FT_CATEGORIA: Yup.string().required('* Campo obrigatório. Selecione uma opção da lista'),
		//CERTIFICADOREGISTRO: Yup.string().optional(),
		//CAPCIDADEPOTENCIACILINDRADA: Yup.string().optional(),
		//NUMEROCHASSI: Yup.string().optional(),
		//NUMEROMOTOR: Yup.string().nullable(),
		//CAPACIDADECOMBUSTIVEL: Yup.string().optional(),
		//RENAVAM: Yup.string().optional(),
		//ANOLICENCIADO: Yup.string().required('* Campo obrigatório'),
		//FT_TIPOQUILOMETRAGEM: Yup.string().optional(),
		FT_MARCA: Yup.string().required('* Campo obrigatório. Selecione uma opção da lista'),
		TIPOCOMBUSTIVEL: Yup.string().required('* Campo obrigatório. Selecione uma opção da lista'),
		ORGAOUNIDADE: Yup.string().required('* Campo obrigatório'),
		STATUS: Yup.number().required('* Campo obrigatório. Selecione uma opção da lista'),
		//FT_ESPECIE: Yup.string().optional(),
	});

	const getAllVehicleData = () => {
		setLoading(true);
		api.post(`get-vehicles`, { ORGAO: userAgencyId })
			.then((response) => {
				setAllVehiclesData(response.data);
				setLoading(false);
				console.log('getAllVehicleData response:', response.data);
			})
			.catch((response: AxiosResponse) => {
				console.log('erro: ', response.status);
				setLoading(false);
			});
	};

	const getVehicleData = () => {
		if (rows === 0) {
			setLoading(true);
		} else {
			setLoadingRows(true);
		}
		api.post(`get-vehicles2`, { ROW: rows, ORGAO: userAgencyId })
			.then((response) => {
				if (response.status === 204) {
					setMaxData(true);
					setLoading(false);
					setLoadingRows(false);
				} else {
					setVehiclesData(
						vehiclesData.concat(
							response.data.filter((item: any) => {
								return item.ORGAO === userAgencyId;
							})
						)
					);
					setLoadingRows(false);
					setLoading(false);
				}
			})
			.catch((response: AxiosResponse) => {
				console.log('erro: ', response.status);
				setLoadingRows(false);
				setLoading(false);
			});
	};

	const removeVehicle = (vehicle: ModelOfVehicleItem) => {
		setLoading(true);
		api.delete(`vehicles/${vehicle.ID}`)
			.then((response) => {
				const newList = vehiclesData.filter((vehicle) => vehicle.ID !== response.data.ID);
				setVehiclesData(newList);
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Remoção realizada',
					detail: 'O veículo foi removida com sucesso!',
					life: 5000,
				});
			})
			.catch(() => {
				getVehicleData();
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Remoção não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	const editVehicle = (vehicle: ModelOfVehicleItem) => {
		setLoadingEdit(true);

		const editedVehicle: ModelOfVehicleItemForm = {
			...vehicle,
			CAPACIDADECOMBUSTIVEL: vehicle.CAPACIDADECOMBUSTIVEL
			  ? parseFloat(vehicle.CAPACIDADECOMBUSTIVEL.toString().replace(',', '.'))
			  : 0, // Defina um valor padrão, como 0 ou null se necessário
		  
			MARCADORKM: vehicle.MARCADORKM
			  ? parseFloat(vehicle.MARCADORKM.toString().replace(',', '.'))
			  : 0, // Mesmo tratamento para MARCADORKM
		  };
		console.log("Vai atualzar o veiuclo")
		api.put(`vehicles/${selectedVehicle?.ID}`, editedVehicle)
			.then((response) => {
				setEditDialog(false);
				setLoadingEdit(false);
				handleUpload.processUploadFileImage(imageUploading, 'docveiculo', 'FT_VEICULO', response.data.ID);
				toast.current.show({
					severity: 'success',
					summary: 'Edição realizada',
					detail: 'O veículo foi editada com sucesso!',
					life: 5000,
				});
				setTimeout(() => {
					window.location.reload();
				}, 1500);
			})
			.catch((err) => {
				console.log(err);
				getVehicleData();
				setEditDialog(false);
				setLoadingEdit(false);
				toast.current.show({
					severity: 'error',
					summary: 'Edição não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	useEffect(() => {
		getVehicleData();
	}, [rows]);

	useEffect(() => {
		getAllVehicleData();
	}, []);

	const openDeleteDialog = (vehicle: ModelOfVehicleItem) => {
		setDeleteDialog(true);
		setSelectedVehicle(vehicle);
	};

	const closeDeleteDialog = () => {
		setDeleteDialog(false);
	};

	const openEditDialog = (vehicle: ModelOfVehicleItem) => {
		setEditDialog(true);
		setSelectedVehicle(vehicle);
	};

	const closeEditDialog = () => {
		setEditDialog(false);
	};

	const formik = useFormik<ModelOfVehicleItem>({
		initialValues: {
			AX_ESTOQUE: '',
			PLACA: '',
			DESCRICAO: '',
			SIGLA: '',
			MARCADORKM: '',
			COR: '',
			ANOFABRICACAO: 0,
			ANOMODELO: 0,
			FT_CATEGORIA: '',
			CERTIFICADOREGISTRO: '',
			CAPCIDADEPOTENCIACILINDRADA: '',
			NUMEROCHASSI: '',
			NUMEROMOTOR: '',
			CAPACIDADECOMBUSTIVEL: '',
			RENAVAM: '',
			ANOLICENCIADO: 0,
			FT_TIPOQUILOMETRAGEM: '',
			FT_MARCA: '',
			TIPOCOMBUSTIVEL: {
				ID: [],
			},
			ORGAOUNIDADE: '',
			STATUS: 1,
			FT_ESPECIE: '',
		},
		onSubmit: (values) => editVehicle(values),
		validationSchema,
	});

	return {
		getListController: {
			formik,
			vehiclesData,
			allVehiclesData,
			selectedVehicle,
			loading,
			loadingRows,
			deleteDialog,
			editDialog,
			loadingEdit,
			toast,
			rows,
			maxData,
		},
		handleListController: {
			removeVehicle,
			editVehicle,
			openDeleteDialog,
			closeDeleteDialog,
			openEditDialog,
			closeEditDialog,
			setRows,
		},
	};
};
